
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import './i18n';
import { App } from "@taskpane/components";
import React from "react";
import '@progress/kendo-theme-default/dist/all.css';
import { createRoot } from "react-dom/client";

initializeIcons();

let isOfficeInitialized = false;

const MOUNT_NODE = document.getElementById("container");

const render = (Component: typeof App) => {
  createRoot(MOUNT_NODE).render(
        <Component isOfficeInitialized={isOfficeInitialized} />
  );
};

/* Render application after Office initializes */
Office.initialize = () => {
  isOfficeInitialized = true;
  render(App);
};

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { App } = require("./components/App");
    render(App);
  });
}
